module.exports = __webpack_public_path__ + "static/media/7.7758f65d.jpg";